/* global __PRA_CONFIG_DATA__, __PRA_SETTINGS__ */

export const PRA_CONFIG_DATA = typeof __PRA_CONFIG_DATA__ !== 'undefined' ? __PRA_CONFIG_DATA__ : {};
export const PRA_SETTINGS = typeof __PRA_SETTINGS__ !== 'undefined' ? __PRA_SETTINGS__ : {};
